export default __webpack_public_path__ + "static/codeleap_logo_black-328e9fbcb4316886c7dde3287999e13e.png";